import { useEffect, useState } from 'react';

type Dictionary = {
  [key: string]: string;
};

export function useTranslation(lang: string) {
  const [dictionary, setDictionary] = useState<Dictionary>({});

  useEffect(() => {
    fetch(`/locales/${lang}.json`)
      .then((res) => res.json())
      .then((data: Dictionary) => setDictionary(data))
      .catch(() => setDictionary({}));
  }, [lang]);

  const t = (key: string): string => dictionary[key] || `[${key}]`;

  return { t };
}
